import React from 'react';
import Plot from 'react-plotly.js';
import { MetricWithSeries } from '../../../api/adminDashboard';
import DashboardCard from './DashboardCard';
import MetricHeader from './MetricHeader';
import { CHART_BLUE, CHART_CONFIG, CHART_TEAL, chartLayout, seriesLabels, seriesValues } from './chartTheme';

interface HoursSavedCardProps {
    hoursSaved: MetricWithSeries;
}

const HoursSavedCard: React.FC<HoursSavedCardProps> = ({ hoursSaved }) => {
    const values = seriesValues(hoursSaved.series);
    const peak = Math.max(...values);
    const barColors = values.map((value) => (value === peak ? CHART_TEAL : CHART_BLUE));

    return (
        <DashboardCard title="Hours saved" className="ad-card-chart ad-col-hours">
            <div className="ad-card-body">
                <MetricHeader displayValue={hoursSaved.displayValue} deltaPct={hoursSaved.deltaPct} />
                <div className="ad-chart">
                    <Plot
                        data={[
                            {
                                type: 'bar',
                                x: seriesLabels(hoursSaved.series),
                                y: values,
                                marker: { color: barColors },
                                width: 0.3,
                            },
                        ]}
                        layout={chartLayout({ bargap: 0.55 })}
                        config={CHART_CONFIG}
                        style={{ width: '100%', height: '100%' }}
                        useResizeHandler={true}
                    />
                </div>
            </div>
        </DashboardCard>
    );
};

export default HoursSavedCard;
